import React, { useEffect, useState } from "react";
import { Box, Modal, useMediaQuery } from "@mui/material";
import IntegrationCard from "../components/dashboard/settings/IntegrationCard";
import Select from "../components/sub-component/Select";
import Button from "../components/sub-component/Button";
import { Tabs, Tab } from "@mui/material";
import { ReactComponent as CrossIcon } from "../assets/icons/Views/dashboard/test-detail/x.svg";
import IntegrationSetting from "../components/dashboard/settings/IntegrationSettings/IntegrationSetting";
import { useDispatch, useSelector } from "react-redux";
import {
  ConnectApps,
  ConnectedApps,
  DeleteConnection,
  GetAllStages,
  GetApps,
  GetJobs,
  IntegrateSettings,
} from "../redux/thunks/Integration";
import Input from "../components/sub-component/Input";
import { setConnected } from "../redux/slices/IntegrationSlice";
import AlertBox from "../components/common/AlertBox";
import { ReactComponent as ErrorIcon } from "../assets/icons/basic/x-circle-error.svg";

export default function Integration() {
  const dispatch = useDispatch();

  const isOnTabletScreen = useMediaQuery(
    "(min-width:0px) and (max-width:1439px)"
  );
  const isOnMobileScreen = useMediaQuery("(max-width: 767px)");
  const [selectedIntegration, setSelectedIntegration] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [alert, setAlert] = useState(null);
  const [apiError, setApiError] = useState("");
  const [appId, setAppId] = useState(null);
  const [selectedCardIntegration, setSelectedCardIntegration] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [integrations, setIntegrations] = useState([]);
  const [apiKey, setApiKey] = useState("");
  const [isConnected, setIsConnected] = useState(false);
  const [connectedAppData, setConnectedAppData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [appToken, setAppToken] = useState(null);



  // const [isOpen, setIsOpen] = useState(null);

  const [activeTab, setActiveTab] = useState("Description");
  const auth = useSelector((state) => state.authReducer);
  const connectedAppId = useSelector((state) => state.authReducer.data.tenant_id)
  const toggleDiv = () => {
    setSelectedIntegration(!selectedIntegration);
  };
  useEffect(() => {
    const fetchIntegrations = async () => {
      if (auth?.data?.access_token) {
        setLoading(true)
        try {
          const response = await dispatch(GetApps());
          if (response?.payload) {
            setIntegrations(response.payload.data);
          } else {
            console.error("No payload received");
          }
          setLoading(false);

        } catch (error) {
          setLoading(false);
          console.error("Error fetching integrations:", error);
        }
      }
    };

    fetchIntegrations();
  }, [dispatch, auth?.data?.access_token]);

  const handleIntegrationCardClick = (integration) => {
    if (integration?.auth_type === "api_key") {
      setSelectedCardIntegration(integration);
      setModalOpen(true);
    } else {
      // console.log("Integration Clicked:", integration);
    }
  };

  const handleConnect = async () => {
    setApiError("");
    if (!auth?.data?.access_token || !apiKey) {
      setApiError("API Key is required");
      return;
    }
    try {
      setProcessing(true);
      const response = await dispatch(ConnectApps(apiKey));
      if (response?.meta?.requestStatus === "fulfilled") {
        setIsConnected(true);
        setModalOpen(false);
        setAlert(
          <AlertBox
            style={{ zIndex: "99999" }}
            color="success"
            description={"Integration connected successfully!"}
            title="Success"
            isOpen={true}
            onCloseAlert={() => setAlert(null)}
          />
        );
        if (auth.data.tenant_id) {
          const appResponse = await dispatch(
            ConnectedApps({ id: auth.data.tenant_id })
          );
          if (appResponse?.meta?.requestStatus === "fulfilled") {
            setConnectedAppData(appResponse.payload);
          } else if (
            appResponse.payload?.message === "Requested resource not found"
          ) {
            // localStorage.removeItem("connectedAppId");
          }
        }
      } else {
        // throw new Error("Incorrect API Key");
        const errorMessage =
          (
            response?.payload?.message ||
            response?.error?.message ||
            "something went wrong"
          ).toLowerCase();

        if (errorMessage.toLowerCase().includes("unauthorized")) {
          setApiError("incorrect api key");
        } else {
          setApiError(errorMessage);
        }
      }
    } catch (error) {
      if (error.message?.toLowerCase().includes("unauthorized")) {
        setApiError("incorrect api Key");
      } else {
        setApiError(
          (error?.message || "unexpected error occurred").toLowerCase()
        );
      }
    } finally {
      setProcessing(false);
    }
  };

  useEffect(() => {
    const fetchConnectedApp = async () => {
      if (connectedAppId) {
        try {
          setLoading(true);
          const response = await dispatch(
            ConnectedApps({ id: connectedAppId })
          );
          // console.log(response,'response223311');

          if (response?.meta?.requestStatus === "fulfilled") {
            setIsConnected(true);
            setConnectedAppData(response.payload);
            setAppToken(response.payload.access_token)
          }
          setLoading(false);
        } catch (error) {
          setLoading(false);
          console.error("Error fetching connected app:", error);
        }
      }
    };

    fetchConnectedApp();
  }, [connectedAppId, dispatch]);


  const handleConnectionDelete = async () => {
    if (auth?.data?.access_token) {
      try {
        setProcessing(true);
        const deleteConnection = await dispatch(DeleteConnection());
        if (deleteConnection?.meta?.requestStatus === "fulfilled") {
          setIsConnected(false);
          setProcessing(false);
          setSelectedIntegration(false);
        }
        setProcessing(false);
      } catch (error) {
        console.error("Error deleting connection:", error);
        setProcessing(false);
      }
    }
  };
  if (loading) {
    return (
      <div style={{ height: "80vh", width: "100%", margin: "auto" }}>
        <div className="processing-indicator-wrapper medium-indicator w-100 h-100 d-flex align-items-center justify-content-center">
          <div
            className="processing-indicator primary"
            style={{ width: "40px", height: "40px" }}
          />
        </div>
      </div>
    );
  }


  return (
    <>
      {alert}
      {isOnTabletScreen ? (
        <div
          className="api-access-token-main-container"
          style={{ gap: "24px" }}
        >
          <div
            className="dashboard-page hide-scrollbar"
            style={{
              overflow: "hidden",
              width: "100%",
              transition: "all 0.1s ease-in-out",
            }}
          >
            <div
              className="d-flex align-items-center justify-content-between"
              style={{
                padding: "12px",
                width: "99%",
                margin: "auto",
                height: "68px",
              }}
            >
              <span className="headline-3 dark-100">Integrations</span>
            </div>

            <div
              className="api-access-token-container hide-scrollbar"
              style={{
                flexDirection: "column",
                gap: "16px",
                marginTop: "24px",
                display: selectedIntegration ? "none" : "flex",
              }}
            >
              <div className="d-flex w-100 align-items-center justify-content-between">
                <span className="dark-50 body-2 autiomation-header">
                  Seamless Integrations for Effortless Workflow Automation
                </span>
                <div>
                  {/* <Select
                    readOnly
                    style={{ width: "132px" }}
                    varrient="primary"
                    placeholder={"Category"}
                  /> */}
                </div>
              </div>
              <div
                className="d-flex"
                style={{
                  width: "100%",
                  gap: "24px",
                  flexDirection: selectedIntegration ? "column" : "row",
                }}
              >
                <div className="integration-card" style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
                  {integrations?.map((app) => (
                    <div
                      key={app.id}
                      style={{ width: selectedIntegration ? "100%" : "346px" }}
                    >
                      {!isConnected ? (
                        <IntegrationCard
                          style={{
                            width: selectedIntegration ? "100%" : "346px",
                          }}
                          name={app?.name}
                          isConnected={isConnected}
                          logo={app?.image}
                          status={app?.category === "Ats" ? "ATS" : "Other"}
                          onClick={() =>
                            handleIntegrationCardClick(app.integration)
                          }
                        />
                      ) : (
                        <IntegrationCard
                          style={{
                            width: selectedIntegration ? "100%" : "346px",
                          }}
                          name={app?.name}
                          isConnected={isConnected}
                          logo={app?.image}
                          status={app?.category === "Ats" ? "ATS" : "Other"}
                          // onClick={toggleDiv}
                          onClick={() => setSelectedIntegration(app)}
                        />
                      )}
                    </div>
                  ))}

                  {/* Modal */}
                  {modalOpen &&
                    selectedCardIntegration?.auth_type === "api_key" &&
                    !isConnected && (
                      <Modal
                        integration={selectedCardIntegration}
                        open={modalOpen}
                        onClose={() => setModalOpen(false)}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box>
                          <div
                            className="decline-assessment-modal-container"
                            style={{ padding: "0px", borderRadius: "24px" }}
                          >
                            <div className="detail d-flex flex-column">
                              <div style={{ padding: "24px" }}>
                                <span className="w-100 d-flex justify-content-center headline-small" style={{ fontSize: '24px' }}>
                                  Enter your Workable API key
                                </span>
                                <div
                                  className="w-100 d-flex w-100 d-flex justify-content-center"
                                  style={{ gap: "12px" }}
                                >
                                  <span
                                    className="body-2 dark-50 mt-3 mb-2"
                                    style={{ color: "#6F2DBD", fontSize: '14px' }}
                                  >
                                    <a
                                      href="https://help.workable.com/hc/en-us/articles/115015785428-Generating-revoking-access-tokens-for-Workable-s-API"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{ color: "#6F2DBD" }}
                                    >
                                      Click here
                                    </a>{" "}
                                    to find out how to generate your Workable
                                    API token.
                                  </span>
                                </div>

                                <div style={{ marginTop: "16px" }}>
                                  <Input
                                    value={apiKey}
                                    onChange={(e) => setApiKey(e.target.value)}
                                    placeholder="Enter API Key"
                                    className={apiError ? "error-input" : ""}
                                  />

                                  {apiError ? (
                                    <div className="d-flex danger-text mt-2 align-items-center">
                                      <div style={{ width: "30px" }}>
                                        <ErrorIcon />
                                      </div>
                                      {apiError}
                                    </div>
                                  ) : null}
                                </div>

                                {/* Required Permissions Section */}
                                <div
                                  className="d-flex flex-column"
                                  style={{
                                    background: "#F7F7FA",
                                    padding: "16px",
                                    borderRadius: "12px",
                                    gap: "12px",
                                    marginTop: "24px",
                                  }}
                                >
                                  <span className="body-1 semibold dark-100" style={{ marginBottom: "8px" }}>
                                    Required Permissions
                                  </span>
                                  <ul className="body-2 dark-100" style={{ paddingLeft: "20px", margin: 0 }}>
                                    <li style={{ marginBottom: "6px" }}>📄 Read Jobs (r_jobs): Allows the app to read job postings.</li>
                                    <li style={{ marginBottom: "6px" }}>✏️ Write Candidates (w_candidates): Allows creating or updating candidate information.</li>
                                    <li style={{ marginBottom: "6px" }}>💬 Write Comments (w_comments): Allows adding comments or notes on candidates.</li>
                                    <li>👀 Read Candidates (r_candidates): Allows reading candidate details and profiles.</li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <hr className="hr" style={{ marginTop: "-10px" }} />

                            <div className="w-100 d-flex flex-row justify-content-between">
                              <div />
                              <div
                                className="btn d-flex flex-row w-100"
                                style={{
                                  justifyContent: "space-between",
                                  padding: "24px",
                                }}
                              >
                                <Button
                                  btn="ragular-btn"
                                  varrient="secondary-btn-v2"
                                  title={"Cancel"}
                                  style={{ width: "120px", height: "52px", fontSize: '16px' }}
                                  onClick={() => setModalOpen(false)}
                                  // disabled={props.processing}
                                  // processing={processing}
                                  rounded
                                />

                                <Button
                                  // processing={props.processing}
                                  btn="ragular-btn"
                                  varrient="primary"
                                  title={"Submit"}
                                  style={{ width: "120px", height: "52px", fontSize: '16px' }}
                                  onClick={handleConnect}
                                  processing={processing}
                                  rounded
                                />
                              </div>
                            </div>
                          </div>
                        </Box>
                      </Modal>
                    )}
                </div>
              </div>
            </div>

            <div
              className="api-access-token-container hide-scrollbar"
              style={{
                flexDirection: "column",
                gap: "16px",
                marginTop: "24px",
                display: selectedIntegration ? "flex" : "none",
              }}
            >
              <div
                style={{
                  height: "100vh",
                  width: "100%",
                  background: "white",
                  padding: "24px",
                  gap: "24px",
                  transition: "all 0.1s ease-in-out",
                  borderRadius: "24px",
                }}
                className="integration-container"
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "24px",
                  }}
                >
                  <div className="d-flex dark-100 headline-4 justify-content-between align-items-center">
                    <h5 className="headline-4 dark-100 integration-ats-title">
                      Configure {selectedIntegration?.name} Integration
                    </h5>
                    <div
                      className="d-flex justify-content-between align-items-center"
                      style={{ gap: "12px" }}
                    >
                      <Button
                        btn="ragular-btn"
                        varrient="secondary-btn"
                        title={"Disconnect"}
                        processing={processing}
                        style={{
                          height: "40px",
                          marginTop: "0px",
                          width: "100px",
                        }}
                        onClick={handleConnectionDelete}
                      />
                      <div className="pointer" onClick={toggleDiv}>
                        <CrossIcon style={{ width: "44px", height: "44px" }} />
                      </div>
                    </div>
                  </div>
                  <Tabs
                    value={activeTab}
                    onChange={(event, newValue) => setActiveTab(newValue)}
                    variant="fullWidth"
                    centered
                    TabIndicatorProps={{
                      style: { backgroundColor: "#121216" },
                    }}
                  >
                    {["Description", "Settings"].map((tab) => (
                      <Tab
                        key={tab}
                        label={tab}
                        value={tab}
                        className="body-1"
                        sx={{
                          textTransform: "none",
                          fontSize: "14px",
                          fontWeight: "400",
                          color: activeTab === tab ? "#121216" : "#808191",
                          borderBottom:
                            activeTab === tab
                              ? "2px solid #121216"
                              : "2px solid #ECEDF1",
                          transition: "all 0.1s ease-in-out",
                          "&.Mui-selected": {
                            color: "#121216 !important",
                          },
                        }}
                      />
                    ))}
                  </Tabs>
                </div>

                <div className="body-1">
                  {activeTab === "Description" && (
                    <p className="text-start body-1 dark-100 mt-4">
                      Link Workable jobs to Testfuse assessments and automate
                      candidate evaluations. When a candidate applies to a
                      Workable job, they are automatically invited to the linked
                      Testfuse assessment. After evaluating candidates,
                      recruiters update their hiring stage on Testfuse. This
                      triggers an automatic sync, writing the candidate’s
                      results back to their application on Workable—eliminating
                      manual data entry and keeping your hiring process
                      efficient.
                    </p>
                  )}
                  {activeTab === "Settings" && (
                    <IntegrationSetting
                      selectedIntegration={selectedIntegration}
                      appId={selectedIntegration?.integration?.app_id}
                      apiKey={apiKey}
                      connectedAppData={connectedAppData}
                      setConnectedAppData={setConnectedAppData}
                      connectedAppId={connectedAppId}
                    />
                  )}
                  {activeTab === "Error" && (
                    <p>Error logs for {selectedIntegration?.name}</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div
          className="api-access-token-main-container"
          style={{ gap: "24px" }}
        >
          <div
            className="dashboard-page hide-scrollbar"
            style={{
              overflow: "hidden",
              width: selectedIntegration ? "50%" : "100%",
              transition: "all 0.1s ease-in-out",
            }}
          >
            <div
              className="d-flex align-items-center justify-content-between"
              style={{
                padding: "12px",
                width: "99%",
                margin: "auto",
                height: "68px",
              }}
            >
              <span className="headline-3 dark-100">Integration</span>
            </div>

            <div
              className="api-access-token-container d-flex hide-scrollbar"
              style={{
                flexDirection: "column",
                gap: "16px",
                marginTop: "24px",
              }}
            >
              <div className="d-flex w-100 align-items-center justify-content-between">
                <span className="dark-50 body-2">
                  Seamless Integrations for Effortless Workflow Automation
                </span>
                <div>
                  {/* <Select
                    readOnly
                    style={{ width: "132px" }}
                    varrient="primary"
                    placeholder={"Category"}
                  /> */}
                </div>
              </div>
              <div
                className="d-flex"
                style={{
                  width: "100%",
                  gap: "24px",
                  flexDirection: selectedIntegration ? "column" : "row",
                }}
              >
                <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
                  {integrations?.map((app) => (
                    <div
                      key={app.id}
                      style={{ width: selectedIntegration ? "100%" : "346px" }}
                    >
                      {!isConnected ? (
                        <IntegrationCard
                          style={{
                            width: selectedIntegration ? "100%" : "346px",
                          }}
                          name={app?.name}
                          isConnected={isConnected}
                          logo={app?.image}
                          status={app?.category === "Ats" ? "ATS" : "Other"}
                          onClick={() =>
                            handleIntegrationCardClick(app.integration)
                          }
                        />
                      ) : (
                        <IntegrationCard
                          style={{
                            width: selectedIntegration ? "100%" : "346px",
                          }}
                          name={app?.name}
                          isConnected={isConnected}
                          logo={app?.image}
                          status={app?.category === "Ats" ? "ATS" : "Other"}
                          onClick={() => setSelectedIntegration(app)}
                        />
                      )}
                    </div>
                  ))}

                  {/* Modal */}
                  {modalOpen &&
                    selectedCardIntegration?.auth_type === "api_key" &&
                    !isConnected && (
                      <Modal
                        integration={selectedCardIntegration}
                        open={modalOpen}
                        onClose={() => setModalOpen(false)}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box>
                          <div
                            className="decline-assessment-modal-container"
                            style={{ padding: "0px", borderRadius: "24px" }}
                          >
                            <div className="detail d-flex flex-column">
                              <div style={{ padding: "24px" }}>
                                <span className="w-100 d-flex justify-content-center headline-small">
                                  Enter your Workable API key
                                </span>
                                <div
                                  className="w-100 d-flex w-100 d-flex justify-content-center"
                                  style={{ gap: "12px" }}
                                >
                                  <span
                                    className="body-2 dark-50 mt-3 mb-2"
                                    style={{ color: "#6F2DBD" }}
                                  >
                                    <a
                                      href="https://help.workable.com/hc/en-us/articles/115015785428-Generating-revoking-access-tokens-for-Workable-s-API"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{ color: "#6F2DBD" }}
                                    >
                                      Click here
                                    </a>{" "}
                                    to find out how to generate your Workable
                                    API token.
                                  </span>
                                </div>

                                <div style={{ marginTop: "16px" }}>
                                  <Input
                                    value={apiKey}
                                    onChange={(e) => setApiKey(e.target.value)}
                                    placeholder="Enter API Key"
                                    className={apiError ? "error-input" : ""}
                                  />

                                  {apiError ? (
                                    <div className="d-flex danger-text mt-2 align-items-center">
                                      <div style={{ width: "30px" }}>
                                        <ErrorIcon />
                                      </div>
                                      {apiError}
                                    </div>
                                  ) : null}
                                </div>

                                {/* Required Permissions Section */}
                                <div
                                  style={{
                                    background: "#F7F7FA",
                                    padding: "16px",
                                    borderRadius: "12px",
                                    marginTop: "20px",
                                    marginBottom: "12px"
                                  }}
                                >
                                  <div style={{ fontWeight: 600, fontSize: "16px", marginBottom: "8px" }}>
                                    Required Permissions
                                  </div>
                                  <ul style={{ paddingLeft: "20px", margin: 0 }}>
                                    <li style={{ marginBottom: "6px" }}>📄 Read Jobs (r_jobs): Allows the app to read job postings.</li>
                                    <li style={{ marginBottom: "6px" }}>✏️ Write Candidates (w_candidates): Allows creating or updating candidate information.</li>
                                    <li style={{ marginBottom: "6px" }}>💬 Write Comments (w_comments): Allows adding comments or notes on candidates.</li>
                                    <li>👀 Read Candidates (r_candidates): Allows reading candidate details and profiles.</li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <hr className="hr" style={{ marginTop: "-10px" }} />

                            <div className="w-100 d-flex flex-row justify-content-between">
                              <div />
                              <div
                                className="btn d-flex flex-row w-100"
                                style={{
                                  justifyContent: "space-between",
                                  padding: "24px",
                                }}
                              >
                                <Button
                                  btn="ragular-btn"
                                  varrient="secondary-btn-v2"
                                  title={"Cancel"}
                                  style={{ width: "120px", height: "52px", fontSize: '16px' }}
                                  onClick={() => setModalOpen(false)}
                                  // disabled={props.processing}
                                  // processing={processing}
                                  rounded
                                />

                                <Button
                                  // processing={props.processing}
                                  btn="ragular-btn"
                                  varrient="primary"
                                  title={"Submit"}
                                  style={{ width: "120px", height: "52px", fontSize: '16px' }}
                                  onClick={handleConnect}
                                  processing={processing}
                                  rounded
                                />
                              </div>
                            </div>
                          </div>
                        </Box>
                      </Modal>
                    )}
                </div>
              </div>
            </div>
          </div>

          {selectedIntegration && (
            <div
              style={{
                position: "absolute",
                right: "0",
                top: "0",
                width: "48%",
                height: "100%",
                background: "white",
                padding: "24px",
                gap: "24px",
                transition: "all 0.1s ease-in-out",
                borderRadius: "24px",
                overflowY: 'scroll'

              }}
              className="hide-scrollbar"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "24px",
                }}
              >
                <div className="d-flex dark-100 headline-4 justify-content-between align-items-center">
                  <h5 className="headline-4 dark-100 ">
                    Configure {selectedIntegration?.name} Integration
                  </h5>
                  <div
                    className="d-flex justify-content-between align-items-center"
                    style={{ gap: "12px" }}
                  >
                    <Button
                      btn="ragular-btn"
                      varrient="secondary-btn"
                      title={"Disconnect"}
                      processing={processing}
                      style={{
                        height: "40px",
                        marginTop: "0px",
                        width: "100px",
                      }}
                      onClick={handleConnectionDelete}
                    />
                    <div
                      className="pointer"
                      onClick={() => setSelectedIntegration(null)}
                    >
                      <CrossIcon style={{ width: "44px", height: "44px" }} />
                    </div>
                  </div>
                </div>
                <Tabs
                  value={activeTab}
                  onChange={(event, newValue) => setActiveTab(newValue)}
                  variant="fullWidth"
                  centered
                  TabIndicatorProps={{ style: { backgroundColor: "#121216" } }}
                >
                  {["Description", "Settings"].map((tab) => (
                    <Tab
                      key={tab}
                      label={tab}
                      value={tab}
                      className="body-1"
                      sx={{
                        textTransform: "none",
                        fontSize: "14px",
                        fontWeight: "400",
                        color: activeTab === tab ? "#121216" : "#808191",
                        borderBottom:
                          activeTab === tab
                            ? "2px solid #121216"
                            : "2px solid #ECEDF1",
                        transition: "all 0.1s ease-in-out",
                        "&.Mui-selected": {
                          color: "#121216 !important",
                        },
                      }}
                    />
                  ))}
                </Tabs>
              </div>

              <div className="body-1">
                {activeTab === "Description" && (
                  <p className="text-start body-1 dark-100 mt-4">
                    Link Workable jobs to Testfuse assessments and automate
                    candidate evaluations. When a candidate applies to a
                    Workable job, they are automatically invited to the linked
                    Testfuse assessment. After evaluating candidates, recruiters
                    update their hiring stage on Testfuse. This triggers an
                    automatic sync, writing the candidate’s results back to
                    their application on Workable—eliminating manual data entry
                    and keeping your hiring process efficient.
                  </p>
                )}
                {activeTab === "Settings" && (
                  <IntegrationSetting
                    selectedIntegration={selectedIntegration}
                    appId={selectedIntegration?.integration?.app_id}
                    apiKey={apiKey}
                    connectedAppData={connectedAppData}
                    setConnectedAppData={setConnectedAppData}
                    connectedAppId={connectedAppId}
                  />
                )}
                {activeTab === "Error" && (
                  <p>Error logs for {selectedIntegration?.name}</p>
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
}
